import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 19.799 19.799"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.9 1.414a1 1 0 0 0-2 0V8.9H1.414a1 1 0 0 0 0 2H8.9v7.486a1 1 0 0 0 2 0v-7.486h7.485a1 1 0 0 0 0-2h-7.486Z",
      "data-name": "Group 3527"
    }, null, -1)
  ])))
}
export default { render: render }